import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "../data/site";

export default function MobileSticky() {
  return (
    <>
      <div className="mobile-sticky-spacer" aria-hidden />
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex bg-[#0B1426]" data-testid="mobile-sticky-cta">
        <a
          href={`tel:${COMPANY.phoneTel}`}
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white text-sm uppercase tracking-[0.18em] border-r border-white/10"
          data-testid="mobile-sticky-call"
        >
          <Phone size={14} /> Call
        </a>
        <Link
          to="/quote"
          className="flex-1 flex items-center justify-center py-4 text-sm uppercase tracking-[0.18em]"
          style={{ background: "#C5A059", color: "#fff" }}
          data-testid="mobile-sticky-quote"
        >
          Free Quote
        </Link>
      </div>
    </>
  );
}
